// WorkspaceContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

export const WorkspaceContext = createContext();

export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);

  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }

  return context;
};

export const WorkspaceProvider = ({ children }) => {

  const [activeWorkspace, setActiveWorkspace] = useState(null);

  const value = useMemo(() => ({
    activeWorkspace,
    setActiveWorkspace,
  }), [activeWorkspace]);

  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  );
};
